import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { images } from '../data/images';

const CaseStudies = () => {
  const { t } = useLanguage();

  const caseImages = [
    images.caseStudies.case1,
    images.caseStudies.case2,
    images.caseStudies.case3
  ];

  return (
    <section id="cases" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.cases.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.cases.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {t.cases.items.map((caseStudy, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-teal-500 overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={caseImages[index]}
                  alt={caseStudy.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
              </div>

              <CardHeader>
                <CardTitle className="text-2xl font-bold text-gray-900">
                  {caseStudy.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="space-y-4">
                {/* Problem */}
                <div>
                  <h4 className="font-semibold text-red-600 mb-2">Problem:</h4>
                  <p className="text-gray-600 text-sm">{caseStudy.problem}</p>
                </div>

                {/* Solution */}
                <div>
                  <h4 className="font-semibold text-blue-600 mb-2">Solution:</h4>
                  <p className="text-gray-600 text-sm">{caseStudy.solution}</p>
                </div>

                {/* ROI */}
                <div className="bg-teal-50 p-4 rounded-lg">
                  <div className="flex items-center space-x-2 mb-2">
                    <TrendingUp className="w-5 h-5 text-teal-600" />
                    <h4 className="font-semibold text-teal-800">ROI:</h4>
                  </div>
                  <p className="text-teal-900 text-sm font-medium">{caseStudy.roi}</p>
                </div>

                <Button
                  variant="ghost"
                  className="w-full group-hover:bg-teal-50 group-hover:text-teal-700 transition-colors"
                >
                  {caseStudy.cta}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;